import { modifier } from 'ember-modifier';

interface DropdownContentWrapperSignature {
  Element: HTMLElement;
}

export default modifier<DropdownContentWrapperSignature>(
  function dropdownContentWrapper(element) {
    let backdrop: HTMLDivElement | null = null;

    function createBackdrop() {
      if (backdrop) return;

      backdrop = document.createElement('div');
      backdrop.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 1;
      background: transparent;
      pointer-events: auto;
    `;

      backdrop.addEventListener('click', (event) => {
        // Temporarily disable backdrop to check what's underneath
        backdrop!.style.pointerEvents = 'none';
        const elementBelow = document.elementFromPoint(
          event.clientX,
          event.clientY,
        );
        backdrop!.style.pointerEvents = 'auto';

        // Check if click is inside the dropdown content
        if (elementBelow && !element.contains(elementBelow)) {
          // Click is outside dropdown content, close it
          const clickEvent = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
          });
          document.body.dispatchEvent(clickEvent);
        }
        // If click is inside dropdown, do nothing (let interaction continue)
      });

      // Insert backdrop before the dropdown element in DOM
      if (element.parentElement) {
        element.parentElement.insertBefore(backdrop, element);
      }
    }

    function removeBackdrop() {
      if (backdrop && backdrop.parentElement) {
        backdrop.parentElement.removeChild(backdrop);
        backdrop = null;
      }
    }

    // Create backdrop when dropdown content is shown
    createBackdrop();

    return () => {
      removeBackdrop();
    };
  },
);
